export default "__VITE_ASSET__C0KTI3Mx__"